import { FC } from 'react';
import { Portal } from 'components/Portal/Portal';

import { getJ360ElementNode } from 'utils/getJ360ElementNode';
import { MODAL_ROOT_ID } from 'constants/elements';
import { IBKJCenteredDialogChildrenProps } from 'components/BKJCenteredDialogChildren/BKJCenteredDialogChildren.types';
import {
  BKJCenteredDialogBackdrop,
  StyledBKJDialog,
} from 'components/BKJCenteredDialogChildren/BKJCenteredDialogChildren.styled';
let targetElement = getJ360ElementNode(MODAL_ROOT_ID);

export const BKJCenteredDialogChildren: FC<IBKJCenteredDialogChildrenProps> = (
  props,
): JSX.Element | null => {
  const { isOpen, onClose, bgColor } = props;
  if (!isOpen) return null;

  if (!targetElement) {
    targetElement = document.createElement('div');
    targetElement.setAttribute('id', MODAL_ROOT_ID);
    document.body.appendChild(targetElement);
  }

  return (
    <Portal targetElement={targetElement}>
      <StyledBKJDialog {...props} ref={null} />
      <BKJCenteredDialogBackdrop bgColor={bgColor} onClick={onClose} />
    </Portal>
  );
};
